import React from "react";
import styled from "styled-components";
import { space, SpaceProps, layout, LayoutProps } from "styled-system";

interface StyledProps extends SpaceProps, LayoutProps {
  children?: React.ReactNode;
}


const StyledContainer = styled.div<StyledProps>`
  display: inline-block;
  ${space}
  ${layout}
`;

const TachometerFastSVG: React.FunctionComponent<StyledProps> = (props) => {
  return (
    <StyledContainer {...props} data-testid="tachometer-fast-container">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="100%"
        height="100%"
        viewBox={`0 0 39 30`}
        data-testid="tachometer-fast-svg"
      >
        <defs>
          <path
            id="tachometer_fast"
            d="M25.8 10.8l-5.129 6.522c-.375-.105-.763-.18-1.171-.18-2.393 0-4.333 1.92-4.333 4.287 0 .784.229 1.51.6 2.142h7.466c.372-.632.601-1.358.601-2.142 0-.782-.227-1.504-.596-2.135l5.128-6.522c.553-.701.424-1.71-.283-2.255-.716-.545-1.734-.417-2.282.282zM19.5 0C8.73 0 0 8.634 0 19.286c0 3.535.965 6.847 2.645 9.696.38.644 1.103 1.018 1.858 1.018h29.994c.755 0 1.478-.374 1.858-1.018 1.68-2.849 2.645-6.16 2.645-9.696C39 8.634 30.27 0 19.5 0zm14.372 26.786H5.128c-1.23-2.302-1.878-4.88-1.878-7.5 0-8.862 7.29-16.072 16.25-16.072s16.25 7.21 16.25 16.072c0 2.62-.647 5.198-1.878 7.5z"
          />
        </defs>
        <g fill="none">
          <use fill="#152D6D" xlinkHref="#tachometer_fast" />
          <use fill="#070B16" xlinkHref="#tachometer_fast" />
        </g>
      </svg>
    </StyledContainer>
  );
};

export default TachometerFastSVG;
